/**
 * Tailwind-Klassen der gefuehrten Dialoge — getrennt von den Komponenten in
 * `GefuehrtRahmen.tsx`, weil eine `.tsx` mit Komponenten UND Konstanten das
 * schnelle Neuladen der Entwicklung (react-refresh) ausser Kraft setzt.
 */

export const FOKUS = 'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600';

/** Der eine Hauptknopf: gross und fingerfreundlich, am Telefon volle Breite. */
export const KNOPF_HAUPT = `inline-flex w-full sm:w-auto min-h-12 items-center justify-center gap-2 rounded-xl px-6 py-3 text-base font-bold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 disabled:opacity-40 disabled:cursor-not-allowed ${FOKUS}`;

/** Leise Nebenhandlung als Textknopf. */
export const KNOPF_LEISE = `inline-flex min-h-11 items-center gap-1.5 rounded-lg px-2 text-sm font-bold text-slate-500 hover:text-slate-800 disabled:opacity-40 disabled:cursor-not-allowed ${FOKUS}`;

/** Grosse Antwortknoepfe (Ja/Nein, LPH, Gruppe). Groesse und Innenabstand
 *  setzt der Aufrufer — Tailwind loest doppelte Klassen nicht nach Reihenfolge auf. */
export const KNOPF_WAHL = `inline-flex items-center justify-center rounded-xl border-2 font-black transition-colors disabled:opacity-40 ${FOKUS}`;
export const WAHL_GROSS = 'min-h-14 px-4 py-3';
export const WAHL_AUS = 'border-slate-200 bg-white text-slate-800 hover:border-blue-400 hover:bg-blue-50 active:bg-blue-100';
export const WAHL_AN = 'border-blue-600 bg-blue-50 text-blue-800';

/** Eingabefeld ohne Schriftgroesse; mindestens `text-base`, damit das Telefon beim Tippen nicht zoomt. */
export const FELD_RAHMEN = 'w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-slate-800 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 disabled:bg-slate-50';
export const FELD = `${FELD_RAHMEN} text-base`;
